import React from "react";
import downloadddImg from "../../../assets/Images/browchure/downloadddd.png";

const Brochuer_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
    <div className="img">
        <img
        src={downloadddImg}
        alt="Career"
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Brochuer
        </h1>

       <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-xl leading-relaxed">
            Join our team and build a rewarding career with opportunities to grow.
          </p>

      </div>
    </section>
  );
};

export default Brochuer_Banner;